































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { FilterOperators, FilterTypes } from "@/data/table";
import { IUser } from "@/models/users";
import { UUID } from "@/data/enums";

@Component
export default class UsersTable extends Mixins(FilteringSortingTableStore) {
  @Prop({ default: null })
  public readonly active!: IUser["active"];

  public defaults = {
    limit: 6
  };

  public filters: IFilter[] = [
    {
      key: "firstname",
      label: this.$t("_.firstname"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL
    },
    {
      key: "lastname",
      label: this.$t("_.lastname"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL
    },
    {
      key: "email",
      label: this.$t("_.email"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL
    },
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "firstname",
      label: this.$t("_.firstname")
    },
    {
      field: "lastname",
      label: this.$t("_.lastname")
    },
    {
      field: "email",
      label: this.$t("_.email")
    },
    {
      field: "created_at",
      label: this.$t("_.date_added")
    }
  ];

  public loading = true;
  public dataModule: DataModules = DataModules.USERS;

  public get canList() {
    return this.$userCan("list_users");
  }

  public get canDelete() {
    return this.$userCan("delete_user");
  }

  // Override mixin method
  public getStoreParams(params: any): Promise<any> {
    const defaultParams = { ...this.getFilterForActiveState() };
    return this.$_.merge({ params: defaultParams }, params);
  }

  public getFilterForActiveState() {
    if (!this.$_.isBoolean(this.active)) return {};
    return { "filter[active]": this.active };
  }

  public created() {
    if (!this.canList) {
      this.loading = false;
      return;
    }
    this.apiProps = { brand_id: UUID.ORG, with: "image" };
    this.getData();
  }

  public getUserRoute(user: IUser) {
    return {
      name: "adminUser",
      params: {
        userId: user.id
      }
    };
  }

  public async deleteUser(userId: IUser["id"]) {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$t("_.user") as string).toLowerCase()
          })
        },
        events: {
          confirmed: async () => {
            await this.onDeleteConfirmed(userId);
            confirm.close();
          }
        }
      }
    });
  }

  public onDeleteConfirmed(userId: IUser["id"]): Promise<any> {
    this.table.loading = true;
    return this.$store
      .dispatch(`data/${DataModules.USERS}/remove`, {
        id: userId,
        vm: this
      })
      .then(() => {
        this.$buefy.toast.open({
          message: this.$t("_.object_successfully_removed", {
            object: this.$t("_.user")
          }) as string
        });
        this.getData({ ignoreStored: true });
      })
      .catch(error => {
        this.$buefy.toast.open({
          message: error.message,
          type: "is-danger"
        });
        this.table.loading = false;
      });
  }

  private getSrc(user) {
    return this.$_.get(user, "image.full_url");
  }
}
